import { gql, useQuery } from "@apollo/client";

export const CloseRent = gql`
	mutation CloseRent($id: String) {
		stopRenting(id: $id) {
			_id
		}
	}
`;
